import * as yup from 'yup';

export interface IFrogotPassword {
	email: string;
}

export const frogotPasswordInitialValues: IFrogotPassword = {
	email: '',
};

export const forgotPasswordSchema = yup.object().shape({
	email: yup.string().email().required('required'),
});
